module.exports = __webpack_public_path__ + "img/bushu.b9d51ed7.png";